import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0 0 var(--spacing-space32) 0;
`;

function SmartOffer() {
  return (
    <Container
      dangerouslySetInnerHTML={{
        __html: `
            <esi:include src="/fragment/fspr-marketing-card-fe/offer" onerror="continue" />`,
      }}
    />
  );
}

export default SmartOffer;
